<template>
  <div class="components_warp">
       <div class="top-container">
          <div class="time">
            <i class="el-icon-time"></i> {{ min }}:{{ sec }}
          </div>
          <div v-for="(topic, index) in topics" :key="index">
            <div v-if="index == curIndex">
              <div class="text_bewrite2">
                <p>
                  {{ topic.topic }}
                </p>
              </div>
              <div class="img_list">
                      <div style="width:180px;">
                        <img :src="topic.img[11]" alt="">
                        <div class="p">{{letterArr[0]}}</div>
                      </div>
                      <div style="width:180px;">
                        <img :src="topic.img[12]" alt="">
                        <div class="p">{{letterArr[1]}}</div>
                      </div>
                      <div style="width:180px;">
                        <img :src="topic.img[13]" alt="">
                        <div class="p">{{letterArr[2]}}</div>
                      </div>
                      <div style="width:180px;">
                        <img :src="topic.img[14]" alt="">
                        <div class="p">{{letterArr[3]}}</div>
                      </div>
                  </div>
          <div class="radio-list">
            <section class="light">
              <div  v-for="(t, index) in topic.options" :key="index">
                  <label>
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder"/>
                    <span class="design"></span>
                  </label>
              </div>
            </section>
          </div>
            </div>
          </div>
        </div>
        <div class="btn_warp">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            min:'',
            sec:'',
            end:'',
            startTime:'',
            endTime:'',
            clearTime:'',
            tempTime:'',
            curTempTime:'',
            curIndex: 0,
            topics:[],
            radioVal:'',
            answers: [],
            questionId: "",
            letterArr:["A","B","C","D","E","F","G","H","I"],
            url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp22'}}
        }
    },
     created(){
      this.getTopicApi()
  },
  destroyed(){
    clearTimeout(this.clearTime)
  },
  mounted(){
     this.startTime = new Date().getTime();
    this.end = Date.parse(new Date()) + 480000 // 截止时间为7分钟（1min为60000ms,）
    this.countdown()
  },
  methods: {
    countdown () {
      const end = this.end
      const now = Date.parse(new Date())
      console.log(now)
      const msec = end - now
      console.log(msec)
      if(msec<0) return;

    //  let day = parseInt(msec / 1000 / 60 / 60 / 24)
    //  let hr = parseInt(msec / 1000 / 60 / 60 % 24)
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
    //  this.day = day
    //  this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : '0' + min
      this.sec = sec > 9 ? sec : '0' + sec
      const that = this
      if(min>=0 && sec>=0){
        //倒计时结束
        if(min==0 && sec==0){
          this.saveNode(2,22,()=>{
            this.submit()
          })
        }
       this.clearTime = setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },
     getTopicApi(){
        this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.zrnlList1}`,{},{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            this.topics = res.data.data
            console.log(this.topics)
        })
      },
    next() {

       if (this.radioVal == "") {
        this.$message.error("请选择答案");
        return false;
      }

       this.curTempTime = new Date().getTime();
      if (this.radioVal == 1) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.curTempTime,
          answer: "A",
        });
      } else if (this.radioVal == 2) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.curTempTime,
          answer: "B",
        });
      } else if (this.radioVal == 3) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.curTempTime,
          answer: "C",
        });
      } else if (this.radioVal == 4) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.curTempTime,
          answer: "D",
        });
      }
      this.radioVal = "";

      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(2,22,()=>{
          this.submit()
        })
      }
    },
     submit() {
      //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.zrnlAdd1}`,
          {
            testId: sessionStorage.getItem("testId"),
            time: this.tempTime,
            answers: this.answers,
          },
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
              },
            });
          }
        });
    },
  },
}
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.img_list{
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.img_list .p{
  text-align: center;
  line-height: 50px;
}
.text_bewrite {
  margin: 30px 0 0px 0;
}
.text_bewrite2 p {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.icon_warp span {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f81818;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.top-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box {
  width: 400px;
  height: 250px;
  border: 1px solid red;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  /*background: hsl(0, 0%, 98%);*/
  cursor: pointer;
  position: relative;
  border-radius: 2px;
}

/* input */
.radio_btn {
  opacity: 0;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}
/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  position: relative;
  flex-shrink: 0;
  left:-6px;
}

.design::before,
.design::after {
  content: "";
  display: block;
  
  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  color: #333;
  /* font-weight: bold; */
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

/* other states */
/* input:hover+.design,
  input:focus+.design {
    border: 1px solid var(--primary);
  }
  
  input:hover+.design:before,
  input:focus+.design:before {
    background: var(--primary);
  }
  
  input:hover~.text {
    color: var(--primary);
  } */

/*.radio_btn:focus + .design::after,*/
/*.radio_btn:active + .design::after {*/
/*  opacity: 0.1;*/
/*  -webkit-transform: scale(2.6);*/
/*  transform: scale(2.6);*/
/*}*/

.time {
  position: absolute;
  top: 40px;
  right: 40px;
  color: red;
}

</style>